import React, { useState } from 'react';
import styles from './Header.module.scss';
import { useNavigate } from 'react-router-dom';

function Header() {
  const navigate = useNavigate(); 
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogoClick = () => {
    navigate(`/`);
  };

  const handleCartClick = (e) => {
    e.stopPropagation();
    navigate(`/cart`);
    setMenuOpen(false);
  };

  const handleContactsClick = (e) => {
    e.stopPropagation();
    navigate(`/contacts`);
    setMenuOpen(false);
  };

  const toggleMenu = (e) => {
    e.stopPropagation();
    setMenuOpen(prev => !prev);
  };

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  return (
    <>
      <div 
        onClick={handleLogoClick}
        className={styles.header}
      >
        <img src="/assets/logo.svg" alt="Logo" />
        
        <div className={styles.headerContainer}>
          <p onClick={() => handleNavigate('/')}>ГЛАВНАЯ</p>
          <p onClick={handleContactsClick} className={styles.cartLink}>
            КОНТАКТЫ
          </p>
          <p onClick={handleCartClick} className={styles.cartLink}>
            КОРЗИНА
          </p>
        </div>

        <div 
          className={`${styles.burger} ${menuOpen ? styles.active : ''}`} 
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {menuOpen && (
        <div className={styles.modalOverlay} onClick={() => setMenuOpen(false)}>
          <div className={styles.modalMenu} onClick={(e) => e.stopPropagation()}>
            <p onClick={() => handleNavigate('/')}>ГЛАВНАЯ</p>
            <p onClick={handleContactsClick}>КОНТАКТЫ</p>
            <p onClick={handleCartClick}>КОРЗИНА</p>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
